module.exports = __webpack_public_path__ + "static/2-01c1cff921a2ce782568802720c2d72a.jpg";